export const LOGGED_IN_COOKIE_NAME = "edxloggedin";
export const JWT_PAYLOAD_COOKIE_NAME = "edx-jwt-cookie-header-payload";
export const JWT_SIGNATURE_COOKIE_NAME = "edx-jwt-cookie-signature";
export const OAUTH_URL = "https://api.edx.org/oauth2/v1/access_token";
